import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const Hub = lazy(() => import('./Hub'));
const Saneamento = lazy(() => import('./Saneamento'));
const SaneamentoOc = lazy(() => import('./SaneamentoOc'));
const SaneamentoEmBreve = lazy(() => import('./Saneamento/EmBreve'));

export const suprimentosRoutes = [
    // Tela inicial em cards: cada card só aparece com a permissão da aba (suprimentos.ctp / .oc / .prc).
    {
        path: '/suprimentos',
        element: (
            <ProtectedRoute anyOf={['suprimentos.ctp', 'suprimentos.oc', 'suprimentos.prc']}>
                <Hub />
            </ProtectedRoute>
        ),
    },
    { path: '/suprimentos/saneamento', element: <Navigate to="/suprimentos" replace /> },
    {
        path: '/suprimentos/saneamento/ctp',
        element: (
            <ProtectedRoute permission="suprimentos.ctp">
                <Saneamento />
            </ProtectedRoute>
        ),
    },
    {
        path: '/suprimentos/saneamento/oc',
        element: (
            <ProtectedRoute permission="suprimentos.oc">
                <SaneamentoOc />
            </ProtectedRoute>
        ),
    },
    {
        path: '/suprimentos/saneamento/prc',
        element: (
            <ProtectedRoute permission="suprimentos.prc">
                <SaneamentoEmBreve tipo="PRC" nome="PRC" />
            </ProtectedRoute>
        ),
    },
];
